(function () {
  'use strict';

  function initReveal() {
    var items = document.querySelectorAll('.fa-reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (item) { observer.observe(item); });
  }

  function initDirectorySearch() {
    document.querySelectorAll('[data-fa-directory]').forEach(function (directory) {
      var input = directory.querySelector('[data-fa-directory-search]');
      var cards = Array.prototype.slice.call(directory.querySelectorAll('[data-fa-directory-card]'));
      var count = directory.querySelector('[data-fa-result-count]');
      var empty = directory.querySelector('[data-fa-directory-empty]');
      if (!input || !cards.length) return;
      input.addEventListener('input', function () {
        var query = input.value.trim().toLocaleLowerCase(document.documentElement.lang || undefined);
        var visible = 0;
        cards.forEach(function (card) {
          var show = !query || (card.getAttribute('data-fa-search') || '').indexOf(query) !== -1;
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (count) count.textContent = visible;
        if (empty) empty.hidden = visible !== 0;
      });
    });
  }

  function initApprovedUI() {
    function joinRoot(root, path) {
      return (root || '/').replace(/\/?$/, '/') + path.replace(/^\//, '');
    }

    document.querySelectorAll('[data-fa-header]').forEach(function (header) {
      var drawer = header.querySelector('[data-fa-drawer]');
      var openButton = header.querySelector('[data-fa-menu-toggle]');
      var mobileSearch = header.querySelector('[data-fa-mobile-search]');
      var mobileSearchToggle = header.querySelector('[data-fa-mobile-search-toggle]');
      function setMobileSearch(open) {
        if (!mobileSearch || !mobileSearchToggle) return;
        mobileSearch.hidden = !open;
        mobileSearch.classList.toggle('is-open', open);
        mobileSearchToggle.setAttribute('aria-expanded', String(open));
        if (open) {
          var mobileSearchInput = mobileSearch.querySelector('input[type="search"]');
          if (mobileSearchInput) window.requestAnimationFrame(function () { mobileSearchInput.focus(); });
        } else if (document.activeElement && mobileSearch.contains(document.activeElement)) {
          mobileSearchToggle.focus();
        }
      }
      if (mobileSearchToggle && !mobileSearchToggle.dataset.faBound) {
        mobileSearchToggle.dataset.faBound = 'true';
        mobileSearchToggle.addEventListener('click', function () {
          setMobileSearch(mobileSearchToggle.getAttribute('aria-expanded') !== 'true');
        });
        header.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && mobileSearchToggle.getAttribute('aria-expanded') === 'true') setMobileSearch(false);
        });
      }
      function setDrawer(open) {
        if (!drawer || !openButton) return;
        drawer.hidden = !open;
        openButton.setAttribute('aria-expanded', String(open));
        document.documentElement.classList.toggle('fa-menu-open', open);
        if (open) {
          var firstControl = drawer.querySelector('button, a');
          if (firstControl) firstControl.focus();
        } else if (document.activeElement && drawer.contains(document.activeElement)) {
          openButton.focus();
        }
      }
      if (openButton && !openButton.dataset.faBound) {
        openButton.dataset.faBound = 'true';
        openButton.addEventListener('click', function () { setDrawer(true); });
      }
      header.querySelectorAll('[data-fa-menu-close]').forEach(function (closeButton) {
        if (closeButton.dataset.faBound) return;
        closeButton.dataset.faBound = 'true';
        closeButton.addEventListener('click', function () { setDrawer(false); });
      });
      if (drawer && !drawer.dataset.faLinkBound) {
        drawer.dataset.faLinkBound = 'true';
        drawer.querySelectorAll('a').forEach(function (link) {
          link.addEventListener('click', function () { setDrawer(false); });
        });
      }
      header.querySelectorAll('[data-fa-locale-select]').forEach(function (select) {
        if (select.dataset.faBound) return;
        select.dataset.faBound = 'true';
        select.addEventListener('change', function () { select.form.submit(); });
      });

      var navTrack = header.querySelector('[data-fa-nav-track]');
      var underline = header.querySelector('[data-fa-nav-underline]');
      if (navTrack && underline && !navTrack.dataset.faBound) {
        navTrack.dataset.faBound = 'true';
        var navLinks = Array.prototype.slice.call(navTrack.querySelectorAll('.fa-site-nav__item > a'));
        function moveUnderline(link) {
          var trackBox = navTrack.getBoundingClientRect();
          var linkBox = link.getBoundingClientRect();
          underline.style.width = linkBox.width + 'px';
          underline.style.transform = 'translateX(' + (linkBox.left - trackBox.left) + 'px)';
          underline.style.opacity = '1';
        }
        function restoreUnderline() {
          var active = navTrack.querySelector('.fa-site-nav__item.is-active > a');
          if (active) moveUnderline(active);
          else underline.style.opacity = '0';
        }
        navLinks.forEach(function (link) {
          link.addEventListener('mouseenter', function () { moveUnderline(link); });
          link.addEventListener('focus', function () { moveUnderline(link); });
        });
        navTrack.addEventListener('mouseleave', restoreUnderline);
        navTrack.addEventListener('focusout', function (event) {
          if (!navTrack.contains(event.relatedTarget)) restoreUnderline();
        });
        window.addEventListener('resize', restoreUnderline);
        restoreUnderline();
      }
    });

    document.querySelectorAll('[data-fa-rail]').forEach(function (rail) {
      if (rail.dataset.faBound) return;
      var track = rail.querySelector('[data-fa-rail-track]');
      var dots = rail.querySelector('[data-fa-rail-dots]');
      if (!track || !dots) return;
      rail.dataset.faBound = 'true';
      var items = Array.prototype.slice.call(track.children);
      items.forEach(function (_, index) {
        var dot = document.createElement('span');
        if (index === 0) dot.className = 'is-active';
        dots.appendChild(dot);
      });
      function updateRail() {
        if (!items.length) return;
        var itemWidth = items[0].getBoundingClientRect().width || 1;
        var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
        var activeIndex = Math.max(0, Math.min(items.length - 1, Math.round(track.scrollLeft / (itemWidth + gap))));
        Array.prototype.slice.call(dots.children).forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === activeIndex);
        });
      }
      var railFrame;
      track.addEventListener('scroll', function () {
        if (railFrame) window.cancelAnimationFrame(railFrame);
        railFrame = window.requestAnimationFrame(updateRail);
      }, { passive: true });
      updateRail();
    });

    document.querySelectorAll('.fa-home-thread').forEach(function (thread) {
      if (thread.dataset.faBound) return;
      thread.dataset.faBound = 'true';
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        thread.classList.add('is-drawn');
        return;
      }
      var threadObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            thread.classList.add('is-drawn');
            threadObserver.disconnect();
          }
        });
      }, { threshold: 0.2 });
      threadObserver.observe(thread);
    });

    document.querySelectorAll('[data-fa-footer-group]').forEach(function (group) {
      var toggle = group.querySelector('[data-fa-footer-toggle]');
      var panel = group.querySelector('[data-fa-footer-panel]');
      if (!toggle || !panel || toggle.dataset.faBound) return;
      toggle.dataset.faBound = 'true';
      toggle.setAttribute('aria-expanded', String(!window.matchMedia('(max-width: 800px)').matches));
      toggle.addEventListener('click', function () {
        if (!window.matchMedia('(max-width: 800px)').matches) return;
        var open = !group.classList.contains('is-open');
        group.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
      });
    });
    document.querySelectorAll('[data-fa-approved-home]').forEach(function (home) {
      var toggle = home.querySelector('[data-fa-motion-toggle]');
      if (!toggle || toggle.dataset.faBound) return;
      toggle.dataset.faBound = 'true';
      var media = home.querySelector('[data-fa-hero-media]');
      var videos = media ? Array.prototype.slice.call(media.querySelectorAll('[data-fa-hero-video]')) : [];

      function setToggleState(paused) {
        home.classList.toggle('is-paused', paused);
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.setAttribute('aria-label', paused ? toggle.dataset.faPlayLabel : toggle.dataset.faPauseLabel);
      }

      if (!videos.length) {
        toggle.addEventListener('click', function () {
          setToggleState(!home.classList.contains('is-paused'));
        });
        return;
      }

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var mobileViewport = window.matchMedia('(max-width: 640px)');
      var userPaused = false;
      var activeVideo = null;

      function listen(query, handler) {
        if (query.addEventListener) query.addEventListener('change', handler);
        else query.addListener(handler);
      }

      function hydrate(video) {
        if (!video || video.dataset.faHydrated) return;
        video.querySelectorAll('[data-fa-video-src]').forEach(function (source) {
          source.src = source.dataset.faVideoSrc;
        });
        video.dataset.faHydrated = 'true';
        video.load();
      }

      function pauseAll() {
        videos.forEach(function (video) { video.pause(); });
      }

      function selectActiveVideo() {
        var wanted = mobileViewport.matches ? 'mobile' : 'desktop';
        var selected = videos.find(function (video) { return video.dataset.faHeroVideo === wanted; }) || videos[0];
        videos.forEach(function (video) { video.classList.toggle('is-active', video === selected); });
        activeVideo = selected;
        return selected;
      }

      function showPoster() {
        home.classList.remove('is-video-ready');
      }

      function playActive() {
        if (reducedMotion.matches) return;
        var video = selectActiveVideo();
        hydrate(video);
        video.muted = true;
        var playPromise = video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(function () {
            userPaused = true;
            setToggleState(true);
            showPoster();
          });
        }
      }

      function applyMotionPreference() {
        var reduced = reducedMotion.matches;
        home.classList.toggle('is-reduced-motion', reduced);
        toggle.hidden = reduced;
        if (reduced) {
          pauseAll();
          showPoster();
          setToggleState(false);
          return;
        }
        selectActiveVideo();
        if (userPaused) setToggleState(true);
        else {
          setToggleState(false);
          playActive();
        }
      }

      videos.forEach(function (video) {
        video.addEventListener('canplay', function () {
          if (video === activeVideo && !reducedMotion.matches) home.classList.add('is-video-ready');
        });
        video.addEventListener('error', function () {
          if (video === activeVideo) showPoster();
        });
      });

      toggle.addEventListener('click', function () {
        userPaused = !home.classList.contains('is-paused');
        setToggleState(userPaused);
        if (userPaused) pauseAll();
        else playActive();
      });

      listen(reducedMotion, applyMotionPreference);
      listen(mobileViewport, function () {
        pauseAll();
        showPoster();
        applyMotionPreference();
      });
      applyMotionPreference();
    });

    document.querySelectorAll('[data-fa-search-overlay]').forEach(function (overlay) {
      if (overlay.dataset.faBound) return;
      overlay.dataset.faBound = 'true';
      var inputs = Array.prototype.slice.call(document.querySelectorAll('[data-fa-search-input]'));
      var products = overlay.querySelector('[data-fa-search-products]');
      var title = overlay.querySelector('[data-fa-search-title]');
      var allLink = overlay.querySelector('[data-fa-search-all]');
      var timer;
      function close() { overlay.hidden = true; document.documentElement.classList.remove('fa-search-open'); }
      function open() { overlay.hidden = false; document.documentElement.classList.add('fa-search-open'); }
      function render(items, query) {
        products.innerHTML = '';
        title.textContent = items.length + ' ' + overlay.dataset.resultsLabel + ' “' + query + '”';
        if (!items.length) { var empty = document.createElement('p'); empty.textContent = overlay.dataset.emptyLabel; products.appendChild(empty); return; }
        items.forEach(function (product) {
          var card = document.createElement('a'); card.className = 'fa-approved-search-product'; card.href = product.url;
          var image = document.createElement('img'); image.alt = ''; image.loading = 'lazy'; image.src = product.featured_image && product.featured_image.url ? product.featured_image.url : '';
          var name = document.createElement('strong'); name.textContent = product.title;
          var price = document.createElement('span'); price.textContent = product.price || '';
          card.appendChild(image); card.appendChild(name); card.appendChild(price); products.appendChild(card);
        });
      }
      function search(query) {
        clearTimeout(timer);
        if (query.length < 2) return;
        timer = window.setTimeout(function () {
          var root = overlay.dataset.rootUrl || '/';
          var url = joinRoot(root, 'search/suggest.json') + '?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last';
          fetch(url).then(function (response) { return response.json(); }).then(function (data) {
            var items = (((data || {}).resources || {}).results || {}).products || [];
            render(items, query);
          }).catch(function () { render([], query); });
        }, 180);
      }
      inputs.forEach(function (input) {
        input.addEventListener('focus', function () {
          if (!window.matchMedia('(max-width: 800px)').matches) open();
        });
        input.addEventListener('input', function () {
          inputs.forEach(function (other) { if (other !== input) other.value = input.value; });
          if (allLink) allLink.href = joinRoot(overlay.dataset.rootUrl, 'search') + '?q=' + encodeURIComponent(input.value) + '&type=product';
          if (window.matchMedia('(max-width: 800px)').matches) return;
          open(); search(input.value.trim());
        });
      });
      overlay.querySelectorAll('[data-fa-search-close]').forEach(function (button) { button.addEventListener('click', close); });
      document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !overlay.hidden) close(); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initDirectorySearch();
    initApprovedUI();
  });
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initDirectorySearch();
    initApprovedUI();
  });
})();
